module.exports = __webpack_public_path__ + "static/media/city-bg.dadf4cb3.jpg";